export const DAO_CODE = 'ACTIVITY_TYPES' + '_DAO';
